import React from 'react';
import { SplitPaneTemplate } from 'components';
import { CtEduSummary, CtEduContent, CtEduDetail } from 'containers';

import styles from './EduLayout.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

const CtEduLayout = () => {
  return (
    <div className={cx('eduLayout-wrapper')}>
      <div className={cx('list-area')}>
        <CtEduSummary />
      </div>
      <div className={cx('content-area')}>
        <SplitPaneTemplate listData={<CtEduContent />} detail={<CtEduDetail />} />
      </div>
    </div>
  );
};

export default CtEduLayout;



// WEBPACK FOOTER //
// ./src/script/containers/edu/CtEduLayout.js